import styled, {keyframes} from 'styled-components';
import {Link} from 'react-router-dom';


const slideDown = keyframes`
  from {
    opacity: 0;
    top: 40px;
  }
  to {
    opacity: 1;
    top: 60px;
  }
`;

// export const Wrapper = styled.div`
//   position: fixed;
//   top: 0px;
//   left: 0px;
//   width: 100%;
//   height: 65px;
//   line-height: 70px;
//   padding-left: 20px;
//   padding-right: 20px;
//   z-index: 1000;
//   background: ${({theme:{boldAccentColor,primaryAccentColor}}) => (
//     `linear-gradient(to right, ${primaryAccentColor} 0%,${boldAccentColor} 100%)`
//   )};
// `;

export const Wrapper = styled.div`
  height: 65px;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  background: #fefeff;
  line-height: 65px;
  box-shadow: 0 4px 2px -2px rgba(65,65,65,0.2);
  z-index: 5000;
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
`;

export const Hamburger = styled.div`
  background: rgba(0,0,0,0.1);
  border-radius: 100px;
  height: 50px;
  width: 50px;
  float: right;
  margin-top: 5px;
  padding-top: 12px;
  cursor: pointer;
  position: relative;
  user-select: none;
  border: 1px solid ${({theme:{brightAccentColor}}) => brightAccentColor};
`;

export const Line = styled.div`
  margin: 4px auto;
  height: 3px;
  border-radius: 4px;
  background: #fff;
  width: 25px;
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 40px;
  opacity: 0;
  right: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #fff;
  width: 200px;
  zIndex: '200',
  border-radius: 8px;
  box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.3);
  animation: ${slideDown} 0.5s forwards 1;
`;

export const DropItem = styled(Link)`
  display: block;
  height: 30px;
  line-height: 30px;
  color: ${({theme:{primaryAccentColor}}) => primaryAccentColor};
  font-weight: 500;
  font-size: 14px;
  padding-left: 20px;
  padding-right: 20px;
  transition: 0.3s ease all;

  :hover {
    background: rgba(0,0,0,0.05);
    color: ${({theme:{primaryAccentColor}}) => primaryAccentColor};
    text-decoration: none;
  }
`;

export const SignOut = styled.div`
  display: block;
  height: 30px;
  line-height: 30px;
  color: ${({theme:{primaryAccentColor}}) => primaryAccentColor};
  font-weight: 500;
  font-size: 14px;
  padding-left: 20px;
  padding-right: 20px;
  transition: 0.3s ease all;

  :hover {
    background: rgba(0,0,0,0.05);
    color: ${({theme:{primaryAccentColor}}) => primaryAccentColor};
    text-decoration: none;
  }
`;

export const Copyright = styled.div`
  display: block;
  height: 30px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: x-small;
  color: ${({theme:{primaryAccentColor}}) => primaryAccentColor};
`;

